import { Badge, Text, Tooltip } from "@mantine/core";
import { getBrandStaleness } from "../hooks/useBrandStaleness";

interface StalenessIndicatorProps {
  lastRefreshAt: string | null;
  variant?: "badge" | "text";
}

export function StalenessIndicator({
  lastRefreshAt,
  variant = "badge",
}: StalenessIndicatorProps) {
  const { color, label } = getBrandStaleness(lastRefreshAt);

  const tooltip = lastRefreshAt
    ? new Date(lastRefreshAt).toLocaleString()
    : "No OEM catalog refresh has been run";

  if (variant === "text") {
    return (
      <Tooltip label={tooltip}>
        <Text size="sm" c={color}>
          {label}
        </Text>
      </Tooltip>
    );
  }

  return (
    <Tooltip label={tooltip}>
      <Badge color={color} variant="light">
        {label}
      </Badge>
    </Tooltip>
  );
}
